import {z} from 'zod';

import {
  BaseVoidResponseSchema,
  CreatedAtAndUpdatedBySchema,
  PriceWithAndWithoutVatSchema,
} from '@dms/api/shared';

export const TransferOrderSchema = z
  .object({
    transferOrderId: z.string(),
    transferOrderVariantId: z.string(),
    sourceWarehouseId: z.string(),
    sourceBranchId: z.string(),
    sourceAuthorizationProfileId: z.string(),
    destinationWarehouseId: z.string().optional(),
    destinationBranchId: z.string().nullish(),
    destinationAuthorizationProfileId: z.string().nullish(),
    state: z.enum(['PREPARATION', 'TRANSFER', 'COMPLETED']),
    number: z.string(),
    destinationType: z.enum(['warehouse', 'authorization', 'branch', 'external']),
    issuedAt: z.string().nullish(),
    issuedBy: z.string().nullish(),
    receivedAt: z.string().nullish(),
    receivedBy: z.string().nullish(),
    referenceNumber: z.string().nullish(),
    note: z.string().nullish(),
    totalPurchasePrice: PriceWithAndWithoutVatSchema,
    issueNoteCount: z.number().nullish(),
    receiveNote: z.object({
      receiveNoteId: z.string().nullish(),
      receiveNoteNumber: z.string().nullish(),
      receiveNoteType: z.enum([
        'TRANSFER',
        'EXTERNAL_TRANSFER',
        'OPENING_BALANCE',
        'PURCHASE',
        'CORE_EXCHANGE',
      ]),
      createdAt: z.string().nullish(),
      completedAt: z.string().nullish(),
      note: z.string().nullish(),
    }),
  })
  .merge(CreatedAtAndUpdatedBySchema);
export type TransferOrder = z.infer<typeof TransferOrderSchema>;

/**
 * GET
 */
export const GetTransferOrderRequestSchema = z.object({
  transferOrderId: z.string(),
});
export type GetTransferOrderRequest = z.infer<typeof GetTransferOrderRequestSchema>;

export const GetTransferOrderResponseSchema = TransferOrderSchema;
export type GetTransferOrderResponse = z.infer<typeof GetTransferOrderResponseSchema>;

/**
 * POST
 */
export const PostTransferOrderRequestSchema = z.object({
  transferOrderVariantId: z.string(),
  sourceWarehouseId: z.string(),
  destinationWarehouseId: z.string().nullish(),
  destinationBranchId: z.string().nullish(),
  destinationAuthorizationProfileId: z.string().nullish(),
  note: z.string().nullish(),
});
export type PostTransferOrderRequest = z.infer<typeof PostTransferOrderRequestSchema>;

export const PostTransferOrderResponseSchema = z.object({
  transferOrderId: z.string(),
});
export type PostTransferOrderResponse = z.infer<typeof PostTransferOrderResponseSchema>;

/**
 * PATCH
 */
export const PatchTransferOrderRequestSchema = z.object({
  transferOrderId: z.string(),
  body: z.object({
    sourceWarehouseId: z.string(),
    destinationWarehouseId: z.string().nullish(),
    destinationBranchId: z.string().nullish(),
    destinationAuthorizationProfileId: z.string().nullish(),
    note: z.string().nullish(),
  }),
});
export type PatchTransferOrderRequest = z.infer<typeof PatchTransferOrderRequestSchema>;

export const PatchTransferOrderResponseSchema = BaseVoidResponseSchema;
export type PatchTransferOrderResponse = z.infer<typeof PatchTransferOrderResponseSchema>;

/**
 * DELETE
 */
export const DeleteTransferOrderRequestSchema = z.object({
  transferOrderId: z.array(z.string()),
});
export type DeleteTransferOrderRequest = z.infer<typeof DeleteTransferOrderRequestSchema>;

export const DeleteTransferOrderResponseSchema = BaseVoidResponseSchema;
export type DeleteTransferOrderResponse = z.infer<typeof DeleteTransferOrderResponseSchema>;
